type CapacitorWindow = typeof window & {
  Capacitor?: {
    isNativePlatform?: () => boolean
    isNative?: boolean
    getPlatform?: () => string
    Plugins?: Record<string, unknown>
  }
}

/** Trusted UA token appended by capacitor.config.ts for the native remote shell. */
export const WAGAMOUR_CAPACITOR_SHELL_UA = 'WagamourCapacitorShell'

/**
 * Detects when the app is running inside the Capacitor native shell (iOS/Android).
 * Safe to call during SSR (returns false on the server).
 *
 * Strict: never treat Capacitor JS presence, Plugins, or getPlatform alone as native.
 * Mobile Chrome may expose window.Capacitor with isNativePlatform() === false.
 */
export function isNativeCapacitorApp(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const capacitor = (window as CapacitorWindow).Capacitor
  if (capacitor) {
    if (
      typeof capacitor.isNativePlatform === 'function' &&
      capacitor.isNativePlatform()
    ) {
      return true
    }

    if (typeof capacitor.isNative === 'boolean' && capacitor.isNative) {
      return true
    }
  }

  // Remote shell: appendUserAgent in capacitor.config.ts (WagamourCapacitorShell)
  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.includes(WAGAMOUR_CAPACITOR_SHELL_UA)
  ) {
    return true
  }

  return false
}
